<template src="./template.html" />

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Crumbs from '../breadcrumbs';
import Header from '../header';
import Sidebar from '../sidebar';

export default {
  name: 'Layout',
  components: {
    Crumbs,
    Header,
    Sidebar,
  },
  computed: {
    ...mapGetters([
      'get_sidebar_isOpened',
      'get_user',
      'get_subaccounts',
      'get_user_permission',
      'get_show_app_views',
    ]),
  },
  created() {
    const rutePath = this.$router.history._startLocation;
    if (localStorage.getItem('token') !== null) {
      this.$store.dispatch('STORE_TOKEN', localStorage.token).then(() => {
        this.$store.dispatch('GET_PROFILE').then((profileRes) => {
          this.$store.dispatch('STORE_USER', profileRes);
          this.$store.dispatch('GET_USER_PERMISSIONS', {id: profileRes.id}).then(() => {
            this.$store.dispatch('GET_SUBACCOUNTS').then((response) => {
              // SET SUBACCOUNT
              if(profileRes.active_subaccount_id != null){
                this.$store.dispatch('STORE_ACTIVE_SUBACCOUNT', response.filter((item) => item.id == profileRes.active_subaccount_id)[0]);
                localStorage.setItem('subaccount',  JSON.stringify(response.filter((item) => item.id == profileRes.active_subaccount_id)[0]));
              } else {
                this.$store.dispatch('STORE_ACTIVE_SUBACCOUNT', response.filter((item) => item.is_main == 1 )[0]);
                localStorage.setItem('subaccount',  JSON.stringify(response.filter((item) => item.is_main == 1 )[0]));
              }
              localStorage.userId = profileRes.id;
              this.$store.dispatch('SHOW_APP_VIEWS', true);
            })
          });
        });
      });
    } else {
      this.$store.dispatch('SHOW_APP_VIEWS', true);
    }
  },
  methods: {
    closeFilter() {
      this.$store.dispatch('CLOSE_FILTER_MENU');
    },
  },
}
</script>
